<div class="container-fluid">
    <div class="row justify-content-between align-items-center nav-bar">

        <div class="left-nav d-flex align-items-center">
            <div>
                <button (click)="goBack()" class="navigation__btn" mat-stroked-button color="primary">
                    <mat-icon>keyboard_arrow_left</mat-icon>
                    ÎNAPOI
                </button>

                <!-- Pas 2: Detalii -->
                <div class="breadcrumbs" *ngIf="currentStepIndex === 1">
                    <span (click)="navigationService.goToStep(0)" class="breadcrumbs">
                        Înregistrare Programare
                    </span>
                    <span class="breadcrumbs faded_text">/</span>
                    <span class="breadcrumbs faded_text">
                        Configurare contractuală
                    </span>
                </div>

                <!-- Pas 3: Finalizare -->
                <ng-container *ngIf="currentStepIndex === 2">
                    <span (click)="navigationService.goToStep(0)" class="breadcrumbs ">
                        Înregistrare Programare
                    </span>
                    <span class="faded_text">/</span>
                    <span (click)="navigationService.goToStep(1)" class="breadcrumbs ">
                        Configurare contractuală
                    </span>
                    <span class="breadcrumbs faded_text">/</span>
                    <span class="breadcrumbs faded_text">
                        Finalizare
                    </span>
                </ng-container>
            </div>
        </div>

        <div class="right-nav">
            <button *ngIf="currentStepIndex === 1" type="button" class="right-nav-btn" [disabled]="continuaDisabled"
                (click)="handleContinua()">
                <span>CONTINUĂ</span>
            </button>

            <button *ngIf="currentStepIndex === 2" type="button" class="right-nav-btn" [disabled]="continuaDisabled"
                (click)="handleContinua()">
                <span>FINALIZEAZĂ</span>
            </button>
        </div>

    </div>
</div>